import { gameRounds } from './reducer';

export const { setGameRounds, clearGameRounds, setRoundPhaseStatus } = gameRounds.actions;
